import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { AnswerValueDto, QuizProgress } from '../models';
import { QuizProgressDto } from '../models/progress.dto';

@Injectable({
    providedIn: 'root',
})
export class QuizProgressHttpService {
    private readonly httpClient = inject(HttpClient);

    getProgress(quizId: string): Observable<QuizProgress> {
        return this.httpClient.get<QuizProgressDto>(`library/quizzes/${quizId}/progress`).pipe(mapDto((dto) => new QuizProgress(dto)));
    }

    saveAnswer(quizId: string, questionId: string, optionId: string): Observable<QuizProgress> {
        const body = new AnswerValueDto(optionId);
        return this.httpClient.put<QuizProgressDto>(`library/quizzes/${quizId}/answers/${questionId}`, body).pipe(mapDto((dto) => new QuizProgress(dto)));
    }

    retry(quizId: string): Observable<void> {
        return this.httpClient.delete<void>(`library/quizzes/${quizId}/progress`);
    }
}
